// extracted by extract-css-chunks-webpack-plugin
module.exports = {"item":"item_8nzac","itemFooter":"itemFooter_A8uNN","itemTitle":"itemTitle_rtTrq","itemTag":"itemTag_RPYNv","mask":"mask_A2W-R","ui_mask":"ui_mask_z-2rf"};